export default 'Catalogue fiches CEE | Solution Éco France';
